import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse } from "@/types";

export interface WeeklyCoinReport {
  period: WeeklyCoinReportPeriod;
  weekStart: string;
  weekEnd: string;
  totalCoinsEarned: number;
  categoryTotals: Record<string, number>;
  staffers: {
    userId: number;
    firstName: string | null;
    lastName: string | null;
    coinsEarned: number;
    coinBalance: number;
    totalCoinsEarned: number;
    categoryTotals: Record<string, number>;
  }[];
}

export type WeeklyCoinReportPeriod =
  | "THIS_WEEK"
  | "LAST_WEEK"
  | "THIS_MONTH"
  | "LAST_MONTH";

export const weeklyCoinReportQueryKey = (period: WeeklyCoinReportPeriod) =>
  ["weekly-coin-report", period] as const;

export function useGetWeeklyCoinReport(period: WeeklyCoinReportPeriod) {
  return useQuery({
    queryKey: weeklyCoinReportQueryKey(period),
    queryFn: async () => {
      const response = await guacHttpClient.get<
        WeeklyCoinReport,
        HttpResponse<WeeklyCoinReport>
      >("pets/weekly-coin-report", { params: { period } });
      return response.data;
    },
    staleTime: 60_000,
  });
}
